'use strict';

angular.module('atex.art').factory('CopyfitUtils',
    [
  function() {
    var copyfitUtilsFactory = function() {

      var displayControl = function(control, display) {
        if ( (typeof display === 'undefined') || !display ) {
          control.style.display = 'none';
        } else {
          control.style.display = '';
        }
      };

      var getIntent = function( intents, defaultIntent ) {
        var intent = defaultIntent;

        if (typeof intents !== 'undefined') {
          intent = _.find(intents, function (viewIntent) {
            return defaultIntent === viewIntent;
          });
        }

        return intent;
      };

      var findTemplateFieldByView = function( viewName, fieldIndex ) {
        var templateFieldElements = $('.template-field[x-act-view-name="' + viewName + '"][x-act-field="' + fieldIndex + '"]');

        if (templateFieldElements.length > 0) {
          return templateFieldElements[0];
        }

        return undefined;
      };

      var findTemplateFieldByFieldIndex = function( fieldIndex ) {
        var templateFieldElements = $('.template-field[x-act-field="' + fieldIndex + '"]');

        if (templateFieldElements.length > 0) {
          return templateFieldElements[0];
        }

        return undefined;
      };

      var findTemplateFieldByField = function( template, fieldName ) {
        if ( typeof template.layout === 'undefined' ) {
          // not using views.
          for (var fieldIndex in template.dataBindings) {
            if ( template.dataBindings[fieldIndex].name === fieldName ) {
              return findTemplateFieldByFieldIndex(fieldIndex);
            }
          }
        } else {
          /* jshint -W004 */
          for (var viewIndex in template.layout.views) {
            var view = template.layout.views[viewIndex];
            for (var fieldIndex in view.fields) {
              var name = view.fields[fieldIndex];
              if ( fieldName === name ) {
                return findTemplateFieldByView(view.name, fieldIndex);
              }
            }
          }
          /* jshint +W004 */
        }

        return undefined;
      };

      // The returned object will be an instance of this service.
    return {
      displayControl: displayControl,
      getIntent: getIntent,
      findTemplateFieldByView: findTemplateFieldByView,
      findTemplateFieldByFieldIndex: findTemplateFieldByFieldIndex,
      findTemplateFieldByField: findTemplateFieldByField
    };
  };

  // Return the factory function instead of an object containing it
  return copyfitUtilsFactory;
}]);
